const React = require('react');
const loopMap = require('mn-utils/loopMap');
const colorBase = require('mn-utils/color').base;
const videoRenderProvider = require('mn-utils/browser/videoRenderProvider');
const physicRenderProvider = require('mn-utils/browser/physicRenderProvider');
const viewport$ = require('mn-utils/browser/emitters/viewport');

const DESKTOP = viewport$.getValue()[0] > 992;

const DISTANCE_MULTIPLIER = DESKTOP ? 20 : 60;
const MIN_DISTANCE = DESKTOP ? 40 : 80;

const PHYSIC_SPEED = 0.2;
const PHYSIC_TIME_STEP = DESKTOP ? 4 : 4;

const FADING = DESKTOP ? 2 : 2;


const POINTS_COUNT = DESKTOP
  ? 2000
  : 1000;

const TOUCH_LIMIT = DESKTOP ? 64 : 64;
const SPEED_MAX = DESKTOP ? 0.04 : 0.01;
const SPEED_BRAKING = DESKTOP ? 3 : 2;
const ACC_BRAKING = DESKTOP ? 0.004 : 0.001;

const COUNT_MAX_MIDDLE = 0;
const COUNT_MAX_HIGH = 0;

const RADIUS_MULTIPLIER = 0.01;
const RADIUS_MAX = 3;
const RADIUS_MIDDLE = 2;
const RADIUS_MIN = 1;

const ITEM_RADIUS = 0;
const ITEM_COLOR = 1;
const ITEM_POINT = 2;
const ITEM_ACC = 3;
const ITEM_SPEED = 4;

const constG = 1000;
const colorSpeed = randColor(0.1, 0.5);
const mutationSpeed = 0.001;
const minCV = 0.01;

const mouse = [
  3,
  [0.1, 0.1, 0.1, 1],
  [0, 0],
  [0, 0],
  [0, 0],
];


module.exports = require('./utils/withState')((setState, self, onMount) => {
  onMount(() => {
    const _cancel = require('mn-utils/browser/emitters/mouse')
        .mousemove$.on((e) => {
          _pointer = getPointer(
              e.clientX || e.pageX,
              e.clientY || e.pageY,
          );
        });
    return () => {
      _cancel();
      pause();
    };
  });

  let _node;
  let _ctx;
  let _nodeCanvas;
  let _frame;
  let _framePhysic;
  let _viewport = self.state.viewport;
  let _widthOfWindow = _viewport[0];
  let _heightOfWindow = _viewport[1];
  let _widthOfWindowPart = 0.5 * _widthOfWindow;
  let _heightOfWindowPart = 0.5 * _heightOfWindow;
  let _widthOfRoot = 0;
  let _heightOfRoot = 0;
  let _widthOfPart = 0;
  let _heightOfPart = 0;
  // let _minSize = 0;
  // let _maxSize = 0;
  let _indexOfObj = 0;
  let _pointer = getPointer(0, 0);

  function onRef(node) {
    const initialized = _node;
    node && _node !== node && (
      _node = node,
      initialized ? refresh() : initialize()
    );
  }
  function play() {
    _frame.play();
    _framePhysic.play();
  }
  function pause() {
    _framePhysic.pause();
    _frame.pause();
  }

  function getPointer(x, y) {
    if (_node && _node.getBoundingClientRect) {
      const rect = _node.getBoundingClientRect();
      x -= rect.left;
      y -= rect.top;
    }
    const indent = _widthOfWindow < 992 ? 0 : 5;
    return [
      x - _widthOfWindowPart + indent,
      y - _heightOfWindowPart + indent,
    ];
  }
  function getObj() {
    return [
      _indexOfObj++ < COUNT_MAX_HIGH
        ? RADIUS_MAX
        : (
          _indexOfObj < COUNT_MAX_MIDDLE
            ? RADIUS_MIDDLE
            : RADIUS_MIN
        ),
      xColor(),
      [
        rand(-_widthOfPart, _widthOfPart),
        rand(-_heightOfPart, _heightOfPart),
      ],
      [0, 0],
      [0, 0],
    ];
  }

  function refresh() {
    const parentNode = _nodeCanvas && _nodeCanvas.parentNode;
    parentNode && parentNode.removeChild(_nodeCanvas);
    _nodeCanvas = document.createElement('canvas');
    _node.appendChild(_nodeCanvas);
    _ctx = _nodeCanvas.getContext('2d');
    updateSize();
  }


  function initialize() {
    refresh();
    const __items = loopMap(POINTS_COUNT, getObj);
    const items = __items.concat([mouse]);
    const itemsLength = items.length;

    let _speedMultiplier = 1;
    let _lastTouchIndex = 0;
    let _lastTouchIndexColor = 0;

    _frame = videoRenderProvider((t) => {
      t *= mutationSpeed;
      // очистка
      _ctx.clearRect(0, 0, _widthOfRoot, _heightOfRoot);
      _ctx.fillStyle = '#000';
      _ctx.rect(0, 0, _widthOfRoot, _heightOfRoot);
      _ctx.fill();

      let cv;
      let csi;
      let cd;
      let color;
      let p;
      let r;
      let rr;

      // mouse[ITEM_COLOR] = [ 0.1, 0.1, 0.1, 0 ];

      // (i2 + _lastTouchIndex) % i

      for (let i = Math.max(itemsLength, TOUCH_LIMIT), item; i--;) {
        item = items[(i + _lastTouchIndexColor) % itemsLength];
        color = item[ITEM_COLOR];
        for (csi = 3; csi--;) {
          cv = color[csi] + colorSpeed[csi] * t;
          while (cv > 1) cv = minCV + (cv - 1);
          while (cv < minCV) cv = (cv - minCV + 1);
          color[csi] = cv;
        }

        cd = [0, 0, 0, color[3]];
        for (csi = 3; csi--;) cd[csi] = normalize(color[csi]);
        p = item[ITEM_POINT];
        r = item[ITEM_RADIUS];
        rr = r * 0.5;

        _ctx.beginPath();
        _ctx.fillStyle = colorBase(cd)[0];
        _ctx.arc(
            _widthOfPart + p[0] - rr,
            _heightOfPart + p[1] - rr,
            r,
            0,
            Math.PI * 2,
            true,
        );
        _ctx.fill();
      }
      _lastTouchIndexColor = (_lastTouchIndexColor + TOUCH_LIMIT) % itemsLength;
    }, 100);

    _framePhysic = physicRenderProvider((_t) => {
      const t = _t * PHYSIC_SPEED;

      let speed;
      let sx;
      let sy;
      let sxSqr;
      let sySqr;
      let ss;
      let ssd;
      let acc;
      let p;
      let x;
      let y;
      let r;
      let i;
      let i2;
      let item;
      let xRange;
      let yRange;


      p = mouse[ITEM_POINT];
      mouse[ITEM_POINT] = [
        p[0] * 0.98 + _pointer[0] * 0.02,
        p[1] * 0.98 + _pointer[1] * 0.02,
      ];

      let speedMax = SPEED_BRAKING;

      for (i = itemsLength; i--;) {
        item = items[i];

        r = item[ITEM_RADIUS];
        p = item[ITEM_POINT];
        speed = item[ITEM_SPEED];
        acc = item[ITEM_ACC];

        sx = speed[0] + acc[0] * t;
        sy = speed[1] + acc[1] * t;

        sxSqr = sx * sx;
        sySqr = sy * sy;
        ssd = sxSqr + sySqr;

        ss = Math.sqrt(ssd);

        speedMax = Math.max(speedMax, ss);

        /*
        if (ss > SPEED_BRAKING) {
          accBreaking = ACC_BRAKING * t;
          sx += (accBreaking * sxSqr / ssd) * (sx > 0 ? -1 : 1);
          sy += (accBreaking * sySqr / ssd) * (sy > 0 ? -1 : 1);
        }
        */
        if (ss > SPEED_MAX) {
          sx = sx * (1 - ACC_BRAKING)
            + ACC_BRAKING * (SPEED_MAX * sxSqr / ssd) * (sx > 0 ? 1 : -1);
          sy = sy * (1 - ACC_BRAKING)
            + (SPEED_MAX * sySqr / ssd) * ACC_BRAKING * (sy > 0 ? 1 : -1);
        }

        x = p[0] + sx * _speedMultiplier;
        y = p[1] + sy * _speedMultiplier;

        // x = p[0] + sx;
        // y = p[1] + sy;

        item[ITEM_SPEED] = [sx, sy];
        item[ITEM_ACC] = [0, 0];

        for (i2 = Math.min(i, TOUCH_LIMIT); i2--;) {
          touch(item, items[(i2 + _lastTouchIndex) % i]);
        }

        xRange = _widthOfPart - r,
        yRange = _heightOfPart - r;

        if (x < -xRange && sx < 0) {
          x = xRange * 2 + x;
        }
        if (x > xRange && sx > 0) {
          x = -xRange * 2 + x;
        }
        if (y < -yRange && sy < 0) {
          y = yRange * 2 + y;
        }
        if (y > yRange && sy > 0) {
          y = -yRange * 2 + y;
        }

        item[ITEM_POINT] = [x, y];
      }
      _speedMultiplier = SPEED_BRAKING / speedMax;
      _lastTouchIndex = (_lastTouchIndex + TOUCH_LIMIT) % itemsLength;
    }, PHYSIC_TIME_STEP);

    play();

    const onInit = self.props.onInit;
    onInit && onInit({
      pause,
      play,
    });
  }
  function updateSize() {
    _widthOfRoot = _nodeCanvas.width = _node.offsetWidth;
    _widthOfPart = _widthOfRoot * 0.5;

    _heightOfRoot = _nodeCanvas.height = _node.offsetHeight;
    _heightOfPart = _heightOfRoot * 0.5;
  }

  return (state, props) => {
    _viewport = self.state.viewport;
    _widthOfWindow = _viewport[0];
    _heightOfWindow = _viewport[1];

    _widthOfWindowPart = _widthOfWindow * 0.5;
    _heightOfWindowPart = _heightOfWindow * 0.5;

    _node && updateSize();

    // _minSize = _widthOfRoot > _heightOfRoot ? _heightOfRoot : _widthOfRoot;
    // _maxSize = _widthOfRoot < _heightOfRoot ? _heightOfRoot : _widthOfRoot;

    return (
      <div
        className={'sq (b0|bc00)>canvas ' + (props.className || '')}
        ref={onRef}
      />
    );
  };
}, {
  viewport: viewport$,
});


function touch(item, item2) {
  const r = item[ITEM_RADIUS];
  const p = item[ITEM_POINT];
  const speed = item[ITEM_SPEED];
  const acc = item[ITEM_ACC];

  const r2 = item2[ITEM_RADIUS];
  const p2 = item2[ITEM_POINT];
  const speed2 = item2[ITEM_SPEED];
  const acc2 = item2[ITEM_ACC];

  const xd = p[0] + speed[0] * FADING - (p2[0] + speed2[0] * FADING);
  const yd = p[1] + speed[1] * FADING - (p2[1] + speed2[1] * FADING);

  const xdAbs = MIN_DISTANCE + Math.abs(xd) * DISTANCE_MULTIPLIER;
  const ydAbs = MIN_DISTANCE + Math.abs(yd) * DISTANCE_MULTIPLIER;

  const xdSqr = xdAbs * xdAbs;
  const ydSqr = ydAbs * ydAbs;

  const dd = xdSqr + ydSqr;

  const distance = Math.sqrt(xdSqr + ydSqr)
   - (r + r2) * RADIUS_MULTIPLIER;

  const m = r * r * r;
  const m2 = r2 * r2 * r2;

  const grav = constG * (m * m2)
    / (distance * distance);

  let xGrav = grav * xdSqr / dd;
  if (xd > 0) xGrav = -xGrav;

  let yGrav = grav * ydSqr / dd;
  if (yd > 0) yGrav = -yGrav;

  item[ITEM_ACC] = [
    acc[0] + xGrav / m,
    acc[1] + yGrav / m,
  ];
  item2[ITEM_ACC] = [
    acc2[0] - xGrav / m2,
    acc2[1] - yGrav / m2,
  ];
}


function rand(min, max) {
  return min + Math.random() * (max - min);
}
function randX() {
  return 0.5 + Math.random() * 0.3;
}
function xColor() {
  return [randX(), randX(), 0.5, 1];
}
function randColor(min, max) {
  min || (min = 0);
  max || (max = 1);
  return [rand(min, max), rand(min, max), rand(min, max), 1];
}
function normalize(v) {
  v = v * 2;
  if (v > 1) v = 2 - v;
  return v;
}
